import { ReactNode } from 'react';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import { PostItem, Title } from 'styles-js/postItem';
import PostLink from 'src/modules/shared/links/postLink';
import { PostType } from 'src/constants/types';
type Props = {
  children: ReactNode; // choose postItem or replyItem
  clickMetadata: {
    section: string;
    element?: string;
    origin?: string;
  };
  communitySlug: string;
  isPrivate: boolean;
  postId: number;
  postTypeId: PostType;
  urlEncodedTitle: string;
  title: string;
};
export default function FeedItemContainer({
  children,
  clickMetadata,
  communitySlug,
  isPrivate,
  postId,
  postTypeId,
  urlEncodedTitle,
  title
}: Props) {
  const onClick = () => {
    trackFootfallEvent(Event.Clicked, {
      clickType: 'post-title',
      clickMetadata
    });
  };
  return <PostItem data-sentry-element="PostItem" data-sentry-component="FeedItemContainer" data-sentry-source-file="feedItemContainer.tsx">
      <PostLink communitySlug={communitySlug} isPrivate={isPrivate} postId={postId} postTypeId={postTypeId} urlEncodedTitle={urlEncodedTitle} onClick={onClick} data-sentry-element="PostLink" data-sentry-source-file="feedItemContainer.tsx">
        <Title data-sentry-element="Title" data-sentry-source-file="feedItemContainer.tsx">{title}</Title>
      </PostLink>
      {children}
    </PostItem>;
}